import React, { Component, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import { Pagination } from "../Pagination/Pagination";
import { getMessagemErro } from "../../utils/erro";
import { baixarArquivo } from "../../utils/downloadUtil";
import api from "../../services/api";
import DatePicker, { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { PopupDetalheErroGV } from "./PopupDetalheErroGV";
import SelectSearch from "../UI/SelectSearch/SelectSearch";

registerLocale("pt_br", pt_br);

const mapDispatchToProps = { exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando };

const mapStateToProps = (state) => ({
	user: state.usuarioStore.user,
});

const ResultadoErros = ({ resultados, onAbrirDetalhe }) => {
	const [hoveredRow, setHoveredRow] = useState(null);
	if (!resultados || resultados.length === 0) return null;
	return (
		<div className="br-table" style={{ marginTop: '20px' }}>
			<table>
				<thead>
					<tr>
						<th>ID</th>
						<th>Nome do Arquivo</th>
						<th>Órgão de Origem</th>
						<th>Código</th>
						<th>Descrição</th>
						<th>Data/Hora</th>
						<th>Ação</th>
					</tr>
				</thead>
				<tbody>
					{resultados.map((item, idx) => (
						<tr key={item.idLog || idx}
							onMouseEnter={() => setHoveredRow(idx)}
							onMouseLeave={() => setHoveredRow(null)}
						>
							<td>{item.idLog}</td>
							<td>{item.nomeArquivo}</td>
							<td>{item.nomeOrgaoOrigem || '-'}</td>
							<td>{item.codigo}</td>
							<td>{item.codigoDescricao || item.descricao}</td>
							<td>{item.dataHoraFormatada}</td>
							<td>
								<button
									type="button"
									className="button"
									onClick={() => onAbrirDetalhe(item)}
									title="Ver detalhes"
									style={{
										backgroundColor: '#dbe8fb',
										color: '#1351b4',
										borderRadius: '50%',
										width: '36px',
										height: '36px',
										border: 'none',
										cursor: 'pointer',
										display: 'inline-flex',
										alignItems: 'center',
										justifyContent: 'center',
										boxShadow: hoveredRow === idx ? '0 0 0 2px #1351b4' : 'none',
									}}
								>
									<i className="fas fa-eye"></i>
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export const RelatorioErrosGV = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(
		class extends Component {

			constructor(props) {
				super(props);
				const hoje = new Date();
				const mesPassado = new Date();
				mesPassado.setMonth(mesPassado.getMonth() - 1);
				this.state = {
					dataInicio: mesPassado,
					dataFim: hoje,
					nomeArquivo: '',
					idOrgaoOrigem: '',
					orgaosOrigem: [],
					botoesHabilitados: true,
					resultados: null,
					pesquisaExecutada: false,
					paginaAtual: 0,
					totalPaginas: 0,
					totalElementos: 0,
					popupAberto: false,
					itemDetalhePopup: null,
				};
				this.pesquisar = this.pesquisar.bind(this);
				this.buscarPagina = this.buscarPagina.bind(this);
				this.handleChangePage = this.handleChangePage.bind(this);
				this.baixarRelatorio = this.baixarRelatorio.bind(this);
				this.limpar = this.limpar.bind(this);
				this.handleInputChange = this.handleInputChange.bind(this);
				this.validaFormulario = this.validaFormulario.bind(this);
				this.abrirDetalhe = this.abrirDetalhe.bind(this);
				this.fecharDetalhe = this.fecharDetalhe.bind(this);
			}

			componentDidMount() {
				this.props.limpaMensagem();

				// Buscar lista de órgãos fornecedores
				api.get('/api/orgao/fornecedores-arquivo-gv')
					.then((response) => {
						if (response.data && Array.isArray(response.data)) {
							this.setState({ orgaosOrigem: response.data });
						}
					})
					.catch((erro) => {
						console.error("Erro ao buscar órgãos fornecedores:", erro);
						// Falha silenciosa - dropdown vazio é aceitável
					});
			}

			handleInputChange(evento) {
				const target = evento.target;
				this.setState({ [target.name]: target.value });
			}

			validaFormulario() {
				const { dataInicio, dataFim } = this.state;
				const mensagens = [];
				if (!dataInicio || !dataFim) {
					mensagens.push({ mensagem: "Data início e data fim são obrigatórias." });
				}
				if (dataInicio && dataFim && dataInicio > dataFim) {
					mensagens.push({ mensagem: "A data início deve ser menor ou igual à data fim." });
				}
				if (mensagens.length > 0) {
					this.props.exibeMensagemErro(
						"Não foi possível realizar a operação porque há inconsistências nos campos informados:",
						mensagens
					);
					throw new Error("Formulário inválido.");
				}
			}

			formatarData(data) {
				if (!data) return '';
				const dia = String(data.getDate()).padStart(2, '0');
				const mes = String(data.getMonth() + 1).padStart(2, '0');
				const ano = data.getFullYear();
				return `${dia}/${mes}/${ano}`;
			}

			pesquisar() {
				try {
					this.validaFormulario();
				} catch (e) {
					return;
				}
				this.buscarPagina(0);
			}

			buscarPagina(pagina) {
				const { dataInicio, dataFim, nomeArquivo, idOrgaoOrigem } = this.state;
				const params = {
					dataInicio: this.formatarData(dataInicio),
					dataFim: this.formatarData(dataFim),
					pagina,
				};
				if (nomeArquivo && nomeArquivo.trim()) params.nomeArquivo = nomeArquivo.trim();
				if (idOrgaoOrigem) params.idOrgaoOrigem = idOrgaoOrigem;

				this.props.mostraAguardando();
				this.setState({ botoesHabilitados: false, resultados: null, pesquisaExecutada: false });

				api.get('/api/relatorios/transferencia-gv/erros/pesquisar', { params })
					.then((response) => {
						const { content, totalPages, totalElements } = response.data;
						this.setState({
							resultados: content,
							pesquisaExecutada: true,
							paginaAtual: pagina,
							totalPaginas: totalPages,
							totalElementos: totalElements,
						});
					})
					.catch((erro) => {
						const msg = getMessagemErro("Não foi possível pesquisar erros", erro);
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					})
					.then(() => {
						this.props.escondeAguardando();
						this.setState({ botoesHabilitados: true });
					});
			}

			handleChangePage(pagina) {
				this.buscarPagina(pagina);
			}

			baixarRelatorio(tipo) {
				const { dataInicio, dataFim, nomeArquivo, idOrgaoOrigem } = this.state;
				const params = {
					dataInicio: this.formatarData(dataInicio),
					dataFim: this.formatarData(dataFim),
					formato: tipo,
				};
				if (nomeArquivo && nomeArquivo.trim()) params.nomeArquivo = nomeArquivo.trim();
				if (idOrgaoOrigem) params.idOrgaoOrigem = idOrgaoOrigem;

				this.props.mostraAguardando();
				this.setState({ botoesHabilitados: false });

				api({ method: 'get', url: '/api/relatorios/transferencia-gv/erros/download', params, responseType: 'arraybuffer' })
					.then((response) => {
						baixarArquivo(new Blob([response.data]), `RelatorioErrosGV.${tipo}`);
					})
					.catch((response) => {
						const erro = { data: JSON.parse(Buffer.from(response.data).toString('utf8')) };
						const msg = getMessagemErro("Não foi possível gerar o relatório", erro);
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					})
					.then(() => {
						this.props.escondeAguardando();
						this.setState({ botoesHabilitados: true });
					});
			}

			limpar() {
				this.props.limpaMensagem();
				this.setState({
					dataInicio: null,
					dataFim: null,
					nomeArquivo: '',
					idOrgaoOrigem: '',
					resultados: null,
					pesquisaExecutada: false,
					paginaAtual: 0,
					totalPaginas: 0,
					totalElementos: 0,
				});
			}

			abrirDetalhe(item) {
				this.setState({ popupAberto: true, itemDetalhePopup: item });
			}

			fecharDetalhe() {
				this.setState({ popupAberto: false, itemDetalhePopup: null });
			}

			render() {
				const { dataInicio, dataFim, nomeArquivo, idOrgaoOrigem, orgaosOrigem, botoesHabilitados, resultados, pesquisaExecutada,
					paginaAtual, totalPaginas, totalElementos, popupAberto, itemDetalhePopup } = this.state;
				const botaoPesquisarHabilitado = botoesHabilitados && !!dataInicio && !!dataFim;
				const exibeBotoesDownload = pesquisaExecutada && resultados && resultados.length > 0;

				const inicio = paginaAtual * 10 + 1;
				const fim = Math.min((paginaAtual + 1) * 10, totalElementos);

				return (
					<main id="content" className="page-content p-3">
						<Message />
						<Loading />					{popupAberto && <PopupDetalheErroGV item={itemDetalhePopup} onClose={this.fecharDetalhe} />}						<div style={{ margin: "10px" }}>
							<h1>Relatório de Erros de Grandes Volumes</h1>
						</div>
						<div className="div-form">
							<div className="br-form">

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Data Início: <span className="obrigatorio">*</span></label>
												<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={dataInicio} onChange={(data) => this.setState({ dataInicio: data })} />
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Data Fim: <span className="obrigatorio">*</span></label>
												<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={dataFim} onChange={(data) => this.setState({ dataFim: data })} />
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Nome do Arquivo (Opcional):</label>
												<input
													type="text"
													name="nomeArquivo"
													value={nomeArquivo}
													onChange={this.handleInputChange}
													placeholder="Ex: SIAFI_*"
												/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="idOrgaoOrigem">Órgão de Origem (Opcional):</label>
												<SelectSearch
													id="idOrgaoOrigem"
													name="idOrgaoOrigem"
													options={orgaosOrigem.map((org) => ({ value: org.id, label: org.nome }))}
													includeAllOption={true}
													onChange={this.handleInputChange}
													value={idOrgaoOrigem}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="actions-button">
									<div className="actions justify-content-start">
										<button type="button" className="button is-primary" onClick={this.pesquisar} disabled={!botaoPesquisarHabilitado}>Pesquisar</button>
										{exibeBotoesDownload && <button type="button" className="button is-secondary" onClick={() => this.baixarRelatorio('pdf')} disabled={!botoesHabilitados}>Relatório PDF</button>}
										{exibeBotoesDownload && <button type="button" className="button is-secondary" onClick={() => this.baixarRelatorio('csv')} disabled={!botoesHabilitados}>Relatório CSV</button>}
										<button type="button" className="button is-secondary" onClick={this.limpar} disabled={!botoesHabilitados}>Limpar</button>
										<ButtonBack disabled={!botoesHabilitados} />
									</div>
								</div>

								{pesquisaExecutada && totalElementos === 0 && (
									<p style={{ marginTop: '16px' }}>Nenhum registro encontrado para os filtros informados.</p>
								)}

								<ResultadoErros resultados={resultados} onAbrirDetalhe={this.abrirDetalhe} />

								{totalElementos > 0 && (
									<div style={{ marginTop: '12px' }}>
										<p>Exibindo {inicio} a {fim} de {totalElementos} registros</p>
										{totalPaginas > 1 && (
											<Pagination
												totalPaginas={totalPaginas}
												paginaAtual={paginaAtual}
												onChangePage={this.handleChangePage}
											/>
										)}
									</div>
								)}

							</div>
						</div>
					</main>
				);
			}
		}
	)
);

